import { render, staticRenderFns } from "./support.vue?vue&type=template&id=04b8f9a6&scoped=true"
import script from "./support.vue?vue&type=script&lang=js"
export * from "./support.vue?vue&type=script&lang=js"
import style0 from "./support.vue?vue&type=style&index=0&id=04b8f9a6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b8f9a6",
  null
  
)

export default component.exports